export default function Pagination({ currentPage, pageSize, handlePageChange, handlePageSizeChange, totalCount }) {
  return (
    <div className="flex items-center justify-end gap-x-3 px-6 py-3 w-full">
      <div className="flex items-center gap-2">
        <span className="text-sm text-[#222222]">Display:</span>
        <select
          value={pageSize}
          onChange={handlePageSizeChange}
          className="px-2 py-1 border rounded-lg"
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 text-sm border rounded-md hover:bg-gray-50"
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of{" "}
          {Math.ceil(totalCount) || 1}
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 text-sm border rounded-md hover:bg-gray-50"
          disabled={
            currentPage === Math.ceil(totalCount)
          }
        >
          Next
        </button>
      </div>
    </div>
  )
}